import { useMalware } from "../../context/Dashboard/contextMalware";
import { useThemeMode } from "../../context/contextTheme";
import UrlForm from "./form/url";
import FileForm from "./form/file";
import hexToRGBA from "../../utils/hexToRGBA";

const ScanCard = () => {
  const { theme } = useThemeMode();
  const { activeTab, setActiveTab } = useMalware();
  const cardStyle = {
    width: "100%",
    maxWidth: "800px",
    backgroundColor: theme.background,
    border: `1px solid ${hexToRGBA(theme.textColor, 0.12)}`,
    borderRadius: "24px",
    overflow: "hidden"
  };

  const segmentContainer = {
    backgroundColor: hexToRGBA(theme.textColor, 0.05),
    borderRadius: "12px",
    padding: "4px",
    display: "inline-flex",
    width: "auto"
  };

  const getSegmentStyle = (isActive) => ({
    padding: "8px 32px",
    borderRadius: "8px",
    fontSize: "0.85rem",
    fontWeight: "700",
    transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
    border: "none",
    backgroundColor: isActive ? theme.primary : "transparent",
    color: isActive ? "#ffffff" : theme.textMuted || "#6c757d",
    boxShadow: isActive ? "0 4px 12px rgba(0, 0, 0, 0.15)" : "none",
  });

  return (
    <div className="container py-4 d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
      <div className="card shadow-lg border-0" style={cardStyle}>
        <div className="py-2 px-4 d-flex align-items-center justify-content-between" 
             style={{ 
               backgroundColor: hexToRGBA(theme.textColor, 0.02), 
               borderBottom: `1px solid ${hexToRGBA(theme.textColor, 0.06)}` 
             }}>
          <div className="d-flex align-items-center gap-2">
            <i className="bi bi-shield-lock-fill text-primary"></i>
            <span className="fw-bold small opacity-75" style={{ letterSpacing: '1px', color: theme.textColor, fontSize: '0.7rem' }}>SECURE ENGINE</span>
          </div>
          <span className="badge rounded-pill bg-success-subtle text-success border border-success-subtle" style={{ fontSize: '0.65rem', padding: '4px 8px' }}>LIVE V1.0</span>
        </div>
        <div className="card-body p-4 p-md-5 text-center">
          <div className="mb-4">
            <h1 className="fw-extrabold mb-1" style={{ 
              fontFamily: '"Jersey 20 Charted", "Arial Black", sans-serif', 
              fontSize: '40px',
              color: theme.textColor,
              letterSpacing: '-1px'
            }}>
              {(activeTab === 0) ? "Phishing" : "Malware"} <span style={{ color: theme.primary }}>SCANNER</span>
            </h1>
            {/* <div className="d-flex align-items-center justify-content-center gap-2 mt-2">
              <span className="text-muted small fw-bold" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>INTELLIGENCE BY</span>
              <img 
                src="https://www.virustotal.com/gui/images/logo.svg" 
                alt="VirusTotal" 
                style={{ height: '16px', opacity: 0.7, filter: theme.mode === 'dark' ? 'invert(1)' : 'none' }} 
              />
            </div> */}
          </div>
          <div className="mb-4">
            <div style={segmentContainer}>
              <button 
                type="button"
                style={getSegmentStyle(activeTab === 0)}
                onClick={() => setActiveTab && setActiveTab(0)}
              >
                URL
              </button>
              <button 
                type="button"
                style={getSegmentStyle(activeTab === 1)}
                onClick={() => setActiveTab && setActiveTab(1)}
              >
                FILE
              </button>
            </div>
          </div>
          <div className="p-3 p-md-4 rounded-4 position-relative" style={{ 
            minHeight: 240,
            backgroundColor: hexToRGBA(theme.textColor, 0.015),
            border: `1px dashed ${hexToRGBA(theme.textColor, 0.12)}`,
            transition: "all 0.3s ease"
          }}>
            {activeTab === 0 && <UrlForm />}
            {activeTab === 1 && <FileForm />}
          </div>
          <div className="mt-4 opacity-50">
            <p className="small mb-0 mx-auto" style={{ maxWidth: '540px', fontSize: '0.72rem', lineHeight: '1.6', color: theme.textColor }}>
              By interacting with this interface, you acknowledge that samples will be shared with the global security community.
              <br />
              <strong className="text-danger-subtle">Do not upload sensitive production credentials or PII elements.</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScanCard;